import React from "react";
 import UploadPlanFile from "../../components/Upload/UploadPlanFile";

function UploadPlanFile1({ setPageHeader }) {
  setPageHeader("Upload SB Plan");
  return (
    <div>
      <UploadPlanFile />
      {/* <StablePrime
        url="/textapi"
        data={{ dn: "StableImage1" }}
        identity="StableImage"
      /> */}
    </div>
  );
}

export default UploadPlanFile1;
